var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 153,
    viewBox: "0 0 284 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.178 2.1742C282.178 2.1742 282.404 55.3244 256.084 80.0177C229.764 104.711 153.034 116.978 130.403 78.0875C124.438 67.8356 121.711 52.3219 129.755 44.9578C138.828 36.6508 154.328 42.687 160.749 53.1796C169.729 67.8545 166.255 93.3576 145.375 121.26C103.709 176.941 2.31356 131.125 2.31356 131.125M2.31356 131.125C2.31356 131.125 9.28285 135.93 12.7177 139.886C15.528 143.123 14.4657 150.537 14.4657 150.537M2.31356 131.125C6.33407 131.02 11.0337 132.731 15.886 130.588C19.2985 129.08 20.089 127.879 23.3299 124.601",
    stroke: "#FFA500",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveArrow);
export default __webpack_public_path__ + "static/media/curve-arrow.23ef9b615ac45cd15d9b12b92d641282.svg";
export { ForwardRef as ReactComponent };